/*
  rk Header: setzt .rk-header-scrolled auf der Header-Section, sobald die Seite
  gescrollt ist (Linie unter dem Header).
*/
(() => {
  if (window.RkHeaderScroll) return;
  window.RkHeaderScroll = true;

  let ticking = false;

  const update = () => {
    ticking = false;
    const header = document.querySelector('.section-header');
    if (header) header.classList.toggle('rk-header-scrolled', window.scrollY > 0);
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true }
  );

  document.addEventListener('shopify:section:load', update);
  update();
})();
